"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalTiesComparison = exports.SignalTieRowSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const si_comparison_1 = require("../../Comparison/si-comparison");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const SignalTies_1 = require("../../SignalTies");
const comparison_spec_1 = require("../comparison-spec");
exports.SignalTieRowSchema = z.object({
    signalName: z.string(),
    toSignalName: z.string(),
    connectionType: z.string(),
    componentType: z.string(),
    componentValueAbs: z.string(),
    componentValueMin: z.string(),
    componentValueMax: z.string(),
    componentValueVariance: z.string(),
    polarity: z.union([z.nativeEnum(SignalTies_1.SignalTiePolarity), z.literal('')]).default(''),
});
class SignalTieIdentityAlignment extends comparison_spec_1.SetAlignment {
    identityOf(row, normalize, columns) {
        const universe = columns ?? Object.keys(row);
        return super.identityOf(row, normalize, universe.filter((column) => column !== 'polarity' || normalize(column, row[column], row) !== ''));
    }
}
class SignalTiesComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new SignalTieIdentityAlignment();
        this.membershipScopeColumns = ['signalName', 'toSignalName'];
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return this.alignment.identityOf(row, (column, value, rowContext) => this.normalize(column, value, rowContext), Object.keys(row).sort());
    }
    normalize(column, value, row) {
        if ((column === 'signalName' || column === 'toSignalName') && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        const characteristic = SignalTies_1.TIE_COMPONENT_TYPE_TO_CHARACTERISTIC[row?.componentType];
        if (typeof value === 'string' && value !== '' && characteristic !== undefined) {
            if (column === 'componentValueAbs' || column === 'componentValueMin' || column === 'componentValueMax') {
                return (0, si_comparison_1.formatSIOrSymbolicValue)(value, characteristic);
            }
            if (column === 'componentValueVariance') {
                return SignalTiesComparison.formatVariance(value, characteristic) ?? super.normalize(column, value, row);
            }
        }
        return super.normalize(column, value, row);
    }
    static formatVariance(variance, characteristic) {
        let properties;
        try {
            properties = sigma_engine_shared_1.VarianceChecker.valueVarianceToProperties({ variance }, sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions[characteristic]);
        }
        catch {
            return undefined;
        }
        if (properties === undefined) {
            return undefined;
        }
        const sign = properties.singleSided && properties.value > 0 ? '+' : '';
        return properties.units.short === sigma_engine_shared_1.CommonParameterUnits.percentage.short ?
            `${sign}${properties.value}%`
            : `${sign}${sigma_engine_shared_1.Utils.formatNumericalSIValue(properties.value)}${properties.units.short}`;
    }
}
exports.SignalTiesComparison = SignalTiesComparison;
//# sourceMappingURL=signal-ties.comparison.js.map